import type {BasePanel} from '@Components/panel/panel.types';

export const AI_OPTIONS_HEIGHT = '420px';
export const AI_OPTIONS_WITH_BANNER_HEIGHT = '514px';
export const AI_SUBTITLES_HEIGHT = '390px';
export const AI_SUBTITLES_HEIGHT_PAYG = '450px';
export const AI_IMAGE_HEIGHT = '750px';
export const AI_VOICE_HEIGHT = '750px';
export const AI_VOICE_WRITER_HEIGHT = '500px';
export const AI_VIDEO_HEIGHT = '750px';

export enum AiOption {
  DEFAULT = 'DEFAULT',
  AI_IMAGE = 'AI_IMAGE',
  AI_SUBTITLES = 'AI_SUBTITLES',
  AI_VOICE = 'AI_VOICE',
  AI_VIDEO = 'AI_VIDEO',
}

export interface AiOptionsProps extends BasePanel {
  showNewAiFeaturePulse: boolean;
  defaultPanel?: AiOption;
  onClose: () => void;
  onDone: () => void;
}